import { render, staticRenderFns } from "./JSONResult.vue?vue&type=template&id=16604e39&scoped=true&"
import script from "./JSONResult.vue?vue&type=script&lang=js&"
export * from "./JSONResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16604e39",
  null
  
)

export default component.exports